import { axiosInstance as request } from '@/api/rest.service'

export const getColumnSources = () => request.get('/research-output/column-sources')
export const getDataSources = () => request.get('/research-output/data-sources')
export const updateDataSources = payload => request.put('/research-output/column-sources', payload)
export const getCredentials = () => request.get('/research-output/credentials')
export const updateCredential = (id, payload) => request.put(`/research-output/credentials/${id}`, payload)
